import { SVGProps } from 'react';

const Refresh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={12}
    height={12}
    viewBox='0 0 12 12'
    {...props}
  >
    <path
      d='M8.535 1.465a5.001 5.001 0 0 0 -8.218 1.78l1.171 0.438a3.751 3.751 0 0 1 6.164 -1.335L6.25 3.75H10V0L8.535 1.465ZM5 8.75a3.738 3.738 0 0 1 -2.652 -1.098L3.75 6.25H0V10l1.465 -1.465a5.001 5.001 0 0 0 8.218 -1.78l-1.171 -0.438A3.751 3.751 0 0 1 5 8.75Z'
      fill='#0076C0'
    />
  </svg>
);

export default Refresh;
